<template>
    <section class="features-section">
      <h1 class="section-title">Features</h1>
      <p class="description" style="font-size:0.8em">
          
          </p>
      <div class="features-grid">
        <div v-for="(item, i) in features" :key="i" class="feature-item">
          <div class="icon-wrapper">
            <img :src="item.icon" :alt="item.title" />
          </div>
          <div class="text">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "FeaturesSection",
    data() {
      return {
        features: [
          {
            title: "LIVE TV",
            description: "Watch live TV with the ability to pause and rewind",
            icon: require("@/assets/tv.svg"),
          },
          {
            title: "VIDEO ON DEMAND",
            description: "Watch your favorite movies and series from the video club",
            icon: require("@/assets/vod.svg"),
          },
          {
            title: "RADIO",
            description: "Listen to radio stations from around the world.",
            icon: require("@/assets/radio.png"),
          },
          {
            title: "EPG",
            description: "Choose missed shows from a modern TV interface.",
            icon: require("@/assets/epg.svg"),
          },
          {
            title: "PERSONAL SETTINGS",
            description: "Customize the app components to suit your preferences",
            icon: require("@/assets/settings.svg"),
          },
          {
            title: "SEARCH",
            description: "Quickly browse the available content.",
            icon: require("@/assets/search.svg"),
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .features-section {
  background-color:rgb(2, 7, 22);
    color: white;
    padding: 60px 20px;
    text-align: center;
  }
  
  .section-title {
    font-size: 2.5rem;
    margin-bottom: 40px;
  }
  
  .features-grid {
 
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 100px;
    max-width: 1400px;
    margin: auto;
    margin-top:100px;
  }
  
  .feature-item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    text-align: left;
  }
  
  .icon-wrapper {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #00ffcc, #6600ff);
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    filter: drop-shadow(0 0 10px #0f3b99);
  }
  
  .icon-wrapper img {
    width: 90%;
    height: auto;
    border-radius: 50%;
    background: #000;
    padding: 10px;
  }
  
  .text h3 {
    font-size: 1.4rem;
    margin: 0 0 5px 0;
    color: white;
  }
  
  .text p {
    font-size: 1.2rem;
    color: #bbb;
    margin: 0;
  }
  </style>
  